import React from 'react';
import cx from 'clsx';
import { useStaticQuery, graphql } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';
import Consult from './Consult';
import FeatureProduct from './FeatureProduct';
import FeatureIndustry from './FeatureIndustry';
import * as moduleStyles from './style.module.scss';
import * as themeStyles from '../../assets/theme.module.scss';

const Home = () => {
    const data = useStaticQuery(graphql`query HomeQuery {
  hero1: file(name: {eq: "hero1"}) {
    childImageSharp {
      gatsbyImageData(layout: FIXED)
    }
  }
  hero2: file(name: {eq: "hero2"}) {
    childImageSharp {
      gatsbyImageData(layout: FIXED)
    }
  }
}
`);

    const hero1 = getSrc(data.hero1);
    const hero2 = getSrc(data.hero2);

    return (
        <>
            <section
                className={cx(
                    themeStyles.pt8, themeStyles.pb7, themeStyles.ptMd9, themeStyles.pbMd12, themeStyles.pyLg13, themeStyles.bgLight, themeStyles.bgBetween,
                    moduleStyles.heroBackground,
                )}
                style={{
                    backgroundImage: `url(${hero2}), url(${hero1})`,
                }}
            >
                <div className={themeStyles.container}>
                    <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                        <div
                            className={cx(themeStyles.col12, themeStyles.colMd11, themeStyles.colLg9, themeStyles.textCenter)}
                            data-aos="fade-up"
                        >
                            <h1 className={cx(themeStyles.display2, themeStyles.fontWeightBold)}>
                                為電機產業提供完整的材料解決方案
                            </h1>
                            <p className={cx(themeStyles.lead, themeStyles.textCenter, themeStyles.mb6, themeStyles.mbLg8)}>
                                <span
                                    className={cx(
                                        moduleStyles.subCategory,
                                        moduleStyles.green,
                                    )}
                                >
                                    電機
                                </span>
                                <span className={moduleStyles.dot}>．</span>
                                <span
                                    className={cx(
                                        moduleStyles.subCategory,
                                        moduleStyles.blue,
                                    )}
                                >
                                    電器
                                </span>
                                <span className={moduleStyles.dot}>．</span>
                                <span
                                    className={cx(
                                        moduleStyles.subCategory,
                                        moduleStyles.black,
                                    )}
                                >
                                    絕緣材料
                                </span>
                                <span className={moduleStyles.dot}>．</span>
                                <span
                                    className={cx(
                                        moduleStyles.subCategory,
                                        moduleStyles.yellow,
                                    )}
                                >
                                    電熱
                                </span>
                                <span className={moduleStyles.dot}>．</span>
                                <span
                                    className={cx(
                                        moduleStyles.subCategory,
                                        moduleStyles.red,
                                    )}
                                >
                                    電子
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* <FeatureIndustry /> */}
            <FeatureProduct />
            <section className={cx(themeStyles.py8, themeStyles.pyMd11)}>
                <Consult />
            </section>
        </>
    );
};
export default Home;
